import { render, staticRenderFns } from "./RednessTemplate.vue?vue&type=template&id=1e91a036"
import script from "./RednessTemplate.vue?vue&type=script&lang=js"
export * from "./RednessTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports